<div class="row" *ngIf="student.server_student_id!=0 && !loading">
    <div class="col-sm-6">
        <div class="card">
            <div class="card-header">
                <h3 class="text-center"> Gifts for {{student.fullname}}</h3>
            </div>
            <div class="card-body">
                <table class="table" *ngIf="student.gifts.length >0">
                    <tr><th>Date</th><th>Gift</th><th>Number</th></tr>
                    <tr *ngFor="let gift of student.gifts;">
                        <td class="align-middle">{{gift.datecreated}}</td>
                        <td class="align-middle text-center"><img src="/assets/images/gifts/{{gift.name}}" width="50%"></td>
                        <td class="align-middle text-center">{{gift.count}}</td>
                    </tr>
                  </table>
                  <div class="text-center alert alert-info" *ngIf="student.gifts.length <= 0"> No gifts found </div>
            </div>
        </div>
    </div>  
    
    <div class="col-sm-6">
        <div class="card">
            <div class="card-header">
                <h3 class="text-center"> Available Topics for  {{quizarea_syllabus.name}}</h3>
            </div>
            <div class="card-body">
                <div class="row" *ngIf="quizarea_syllabus.topics.length>0">
                    <div class="col-sm-4 text-center" *ngFor="let topic of quizarea_syllabus.topics;"> 
                    <div class="topic-map">{{topic.name}} </div>
                </div>
                </div>  
            </div>
    </div>
       
       
    </div>
</div>
<app-spinner *ngIf="loading"></app-spinner>
<div class="text-center mt-2">
    <a [routerLink]="['/student/show',student.server_user_id]" class="btn btn-primary"> Back to Quiz. Do More!</a>
</div>
